module.exports = __webpack_public_path__ + "img/IBERDROLA_80X30.a2065e35.png";